module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modifier-list"
  }, [_vm._l((_vm.modifiersByGroup), function(modifier) {
    return [_c('modifier-row', {
      attrs: {
        "modifier": modifier,
        "modifiers": _vm.modifiers
      },
      on: {
        "change": _vm.toggle
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ffbf7b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/_partials/modifier-list.vue
// module id = 263
// module chunks = 1